<template>
  <NavigationBar />

  <div
    class="bg-[#F7F7F7] flex justify-center pb-[140px] md:pb-[168px] pt-[80px] md:pt-[96px] select-none min-h-screen"
    data-testid="testid-content-detail-page"
  >
    <!-- Content or Not Found -->
    <div
      v-if="!isOtherError && !isLoading"
      class="flex flex-col break-words w-[calc(100vw-32px)] md:w-[calc(100vw-64px)] max-w-[736px]"
      data-testid="testid-content-detail-section"
    >
      <!-- Header Section -->
      <div
        class="flex items-center mb-[16px]"
        data-testid="testid-header-section"
      >
        <div
          class="w-[4px] h-[24px] bg-[#EB3333] rounded-[2px] mr-[8px]"
          data-testid="testid-vertical-red-box"
        />
        <p
          class="text-[16px] leading-[24px] font-[700] text-[#292828] md:text-[22px] md:leading-[28px]"
          data-testid="testid-menu-name"
        >
          Auto Club
        </p>
      </div>

      <!-- Not Found Error -->
      <div
        v-if="isError404"
        class="bg-white p-[16px] rounded-[16px] w-[calc(100vw-32px)] md:w-[calc(100vw-64px)] max-w-[736px] h-[482px] md:min-h-[732px] flex justify-center items-center"
      >
        <ErrorNotFound />
      </div>

      <div v-else>
        <ContentDetailCard
          :content-id="contentId"
          :gallery-image-urls="galleryImageUrls"
          :title-th="titleTh"
          :publish-date="publishDate"
          :description-th="descriptionTh"
          :content-type="contentType"
          :jw-link="jwLink"
        />
      </div>
      <ContentDetailRecommend />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useContentDetail } from "@/composables/useContentDetail";

const route = useRoute();
const contentId = route.params.contentid as string;

const {
  isLoading,
  isError404,
  isOtherError,
  titleTh,
  publishDate,
  descriptionTh,
  galleryImageUrls,
  contentType,
  jwLink,
  bannerImage,
  truncatedTitle,
  truncatedDescription,
} = await useContentDetail(contentId);

onBeforeMount(() => {
  scrollToTop();
});

useSeoMeta({
  title: truncatedTitle.value,
  ogTitle: truncatedTitle.value,
  description: truncatedDescription.value,
  ogDescription: truncatedDescription.value,
  ogImage: bannerImage,
  twitterTitle: truncatedTitle.value,
  twitterDescription: truncatedDescription.value,
  twitterImage: bannerImage,
});

useHead({
  title: truncatedTitle.value,
  meta: [
    { name: "description", content: truncatedDescription.value },
    { property: "og:title", content: truncatedTitle.value },
    { property: "og:description", content: truncatedDescription.value },
    {
      property: "og:url",
      content: `${import.meta.env.VITE_AUTOCLUB_DOMAIN}auto-club/${contentId}/`,
    },
    {
      property: "og:image:width",
      content: "1200",
    },
    {
      property: "og:image:height",
      content: "630",
    },
    {
      property: "og:image",
      content: bannerImage,
    },
    {
      property: "og:image:alt",
      content: truncatedTitle.value,
    },
    {
      property: "og:type",
      content: "website",
    },
    { property: "twitter:title", content: truncatedTitle.value },
    { property: "twitter:description", content: truncatedDescription.value },
    {
      property: "twitter:image",
      content: bannerImage,
    },
  ],
});

const scrollToTop = () => {
  window.scrollTo(0, 0);
};
</script>
